var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilePowerPoint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04444 11.2444H10.2667C11.6 11.2444 12.1867 10.9956 12.7556 10.5156C13.3244 10.0267 13.5556 9.33333 13.5556 8.42667C13.5556 7.56444 13.3333 6.88889 12.7556 6.33778C12.1778 5.81333 11.6267 5.55556 10.2667 5.55556H6.44444V14.4444H8.04444V11.2444ZM16.2222 2C16.6937 2 17.1459 2.1873 17.4793 2.5207C17.8127 2.8541 18 3.30628 18 3.77778V16.2222C18 16.6937 17.8127 17.1459 17.4793 17.4793C17.1459 17.8127 16.6937 18 16.2222 18H3.77778C3.30628 18 2.8541 17.8127 2.5207 17.4793C2.1873 17.1459 2 16.6937 2 16.2222V3.77778C2 3.30628 2.1873 2.8541 2.5207 2.5207C2.8541 2.1873 3.30628 2 3.77778 2H16.2222ZM8.04444 10V6.8H10.0889C10.6756 6.8 11.1289 7.02222 11.4222 7.33333C11.7156 7.64444 11.8667 7.97333 11.8667 8.43556C11.8667 8.93333 11.7067 9.28 11.4222 9.55556C11.1378 9.83111 10.8 10 10.1956 10H8.04444Z",
    fill: "#DA6800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilePowerPoint);
export default __webpack_public_path__ + "static/media/IconFilePowerPoint.48dd7b1f.svg";
export { ForwardRef as ReactComponent };